import { registerComponent, asyncRequest, debounce, loading } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "cart-items",
  class CartItems extends WYATTElement {
    SECTIONS_TO_RENDER = [
      {
        name: "cart-count",
        liveRegion: "cart-count",
      },
      {
        name: "cart",
        liveRegion: "cart-items",
      },
      {
        name: "cart",
        liveRegion: "cart-totals",
      },
      {
        name: "cart",
        liveRegion: "cart-checkout",
      },
      {
        name: "cart",
        liveRegion: "cart-recommendations",
      },
    ];

    constructor() {
      super();

      this.removeButtons = this.querySelectorAll("[data-remove-item-button]");
      this.form = this.querySelector("form");
      this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0,
      );

      this.removeButtons.forEach((button) => {
        button.addEventListener("click", this.remove.bind(this));
      });

      this.confirmRegistryAttributes();

      const debouncedChangeHandler = debounce((event) => {
        this.handleChange(event);
      }, 300);

      this.form?.addEventListener("change", debouncedChangeHandler);
    }

    remove(event) {
      const lineEl = event.currentTarget.closest("[data-line-item]");
      const trackingData = this.parseLineItemData(lineEl);

      event.preventDefault();

      this.updateQuantity(trackingData.line, 0, trackingData);
    }

    handleChange(event) {
      const newQty = parseInt(event.target.value, 10);
      const lineEl = event.target.closest("[data-line-item]");
      const trackingData = this.parseLineItemData(lineEl);

      this.updateQuantity(trackingData.line, newQty, trackingData);
    }

    parseLineItemData(el) {
      try {
        return JSON.parse(el.dataset.lineItem);
      } catch (e) {
        return null;
      }
    }

    getSectionNames() {
      return [
        ...new Set(this.SECTIONS_TO_RENDER.map((section) => section.name)),
      ];
    }

    async updateQuantity(line, quantity, trackingContext) {
      const body = {
        line,
        quantity,
        sections: this.getSectionNames(),
        sections_url: WYATT.routes.cart_url,
      };
      const options = {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify(body) },
      };

      loading.add(this);

      const response = await asyncRequest(
        WYATT.routes.cart_change_url,
        options,
        {
          messageOptions: {
            minDelay: 6000,
            appendPoint:
              '[data-mini-cart][active="true"] [data-dialog-messages], #page-messages',
          },
        },
      );

      if (response) {
        this.handleSuccessfulUpdate(response, trackingContext, quantity);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(state, trackingData, newQuantity) {
      const parsedState = JSON.parse(state);

      const qtyDelta = trackingData.quantity - newQuantity;
      if (qtyDelta !== 0) {
        this.publish(WYATT.PubSub.events.cartUpdated, {
          action: qtyDelta > 0 ? "remove" : "add",
          items: [trackingData],
          quantityDelta: Math.abs(qtyDelta),
        });
      }

      this.publish(
        WYATT.PubSub.events.updateDOM,
        this.SECTIONS_TO_RENDER.map(({ liveRegion, name }) => ({
          liveRegion,
          html: parsedState.sections[name],
        })),
      );
    }

    confirmRegistryAttributes() {
      const shouldRemove = this.config.registryRemove
        ? JSON.parse(this.config.registryRemove)
        : false;
      const attributes = {};

      if (!shouldRemove) {
        return;
      }

      this.config.registryAttributes.split(",").forEach((attribute) => {
        if (attribute) {
          attributes[attribute] = null;
        }
      });

      asyncRequest(`${WYATT.routes.cart_update_url}.js`, {
        ...WYATT.config.fetch.post,
        ...{ body: JSON.stringify({ attributes }) },
      });
    }
  },
);
